import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getSitePolicies, getSitePolicyVersionText } from '../../utils/sitePolicy';
import Spinner from '../Spinner';
import PolicyVersionNavigation from './PolicyVersionNavigation';


class PolicyPageText extends Component {
  state = {
    policyStorage: [],
    currentPolicyId: undefined,
    currentPolicyText: undefined,
    isLoading: true,
  };

  componentDidMount() {
    const { policyTypeId } = this.props;

    getSitePolicies(policyTypeId)
      .then((policies) => {
        this.setState({
          policyStorage: policies,
          isLoading: false,
        });
        policies.forEach((item) => {
          if (!item.isArchived) {
            this.setState({
              currentPolicyId: item.id,
              currentPolicyText: item.text,
            });
          }
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        // eslint-disable-next-line no-console
        if (__DEVELOPMENT__) console.log('Failed:', error);
      });
  }

  onClickPolicyNavItem = (id) => {
    this.setState({
      currentPolicyId: id,
      isLoading: true,
    });

    getSitePolicyVersionText(id)
      .then((oldPolicyText) => {
        this.setState({
          currentPolicyText: oldPolicyText,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  renderPolicyNavItem(item) {
    const { currentPolicyId } = this.state;
    const { id, createdAt, version } = item;

    return (
      <PolicyVersionNavigation
        key={id}
        id={id}
        createdAt={createdAt}
        version={version}
        isCurrent={currentPolicyId === id}
        onClickLink={() => this.onClickPolicyNavItem(id)}
      />
    );
  }


  render() {
    const {
      policyStorage,
      currentPolicyText,
      isLoading,
    } = this.state;
    const isShowPolicyNav = policyStorage.length > 1;

    if (isLoading) return <Spinner className="top" />;

    return (
      <Fragment>
        <div
          className="PolicyPageText"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: currentPolicyText }}
        />
        {isShowPolicyNav && (
          <div className="PolicyVersionNavigation">
            <h2>
              Policy Versions
            </h2>
            <ul className="PolicyVersionNavigation__list dot-list">
              {policyStorage.map(item => this.renderPolicyNavItem(item))}
            </ul>
          </div>
        )}
      </Fragment>
    );
  }
}

PolicyPageText.propTypes = {
  policyTypeId: PropTypes.string.isRequired,
};

export default PolicyPageText;
